export default {"src":"/uk/_next/static/media/spot-monitoring.406df65b.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};